export default __webpack_public_path__ + "static/media/Gloves of Deadly Guile.78f8031b.jpg";